<template>
    <div class="event_management mainBody">
        <div class="input_area">
            <div class="input_box">
                <div class="box_top">
                    <div class="input_group" v-if="groupList.item1.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="select">{{groupList.item1.label}}</label>
                        <el-select v-if="groupList.item1.selectOrinput" id="select" class="inputInner" v-model="groupList.item1.value" placeholder="请选择" @change='getEQDetailById'>
                            <el-option
                            v-for="item in groupList.item1.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input_group" v-if="groupList.item2.isShow">
                        <label  class="input_label" for="select">{{groupList.item2.label}}</label>
                        <el-select @change='clearInput'   id="select" class="inputInner" v-model="groupList.item2.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item2.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="input_group">
                        <div class="add_box1">
                            <button class="formButton add_btn1" @click="openDelete" >删除</button>
                            <button class="formButton add_btn1" @click="openAmend" >修改</button>

                        </div>
                    </div>
                    <div class="input_group" >
                        <div class="add_box">
                            <button class="formButton add_btn" @click="submit" >入场</button>
                        </div>
                    </div>
                </div>
            </div>   
        </div>
        <div class="table_area">
            <div class="inner_input_box">
                <div class="input_group_inner" >
                        <label  class="input_label2" for="input">{{groupList.item3.label}}</label>
                        <el-input  id="input" class="inputInner" v-model="groupList.item3.value" placeholder="请输入内容"></el-input>
                </div>
                <div class="input_group_inner" >
                    <label  class="input_label2" for="select">{{groupList.item4.label}}</label>
                        <el-select  id="select" class="inputInner" v-model="groupList.item4.value" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item4.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                </div>
                <div class="input_group_inner" >
                        <label  class="input_label2" for="input">{{groupList.item5.label}}</label>
                        <el-input  id="input" class="inputInner" v-model="groupList.item5.value" placeholder="请输入内容"></el-input>
                </div>
                <div class="input_group_inner" >
                        <label  class="input_label2" for="input">{{groupList.item6.label}}</label>
                        <el-input  id="input" class="inputInner" v-model="groupList.item6.value" placeholder="请输入内容"></el-input>
                </div>
                <div class="input_group_inner bigBox" >
                        <label  class="input_label2" for="input">{{groupList.item7.label}}</label>
                        <el-input
                            class="bigInput"
                            id="input"
                            type="textarea"
                            :rows="5"
                            placeholder="请输入内容"
                            v-model="groupList.item7.value">
                        </el-input>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import css from '@/css/form.css'
import API from '@/api/material.js'

export default {
    name:'event_management',
    data(){
        return{
            checkAll: false,
            checkedEvents: [],
            eventOptions:[],
            isIndeterminate: false,
            value:'',
            editValue:null,
            groupList:{
                item1:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    label:'已有船舶',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item2:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    label:'新增船舶',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item3:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    label:'船龄',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item4:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    label:'船舶类型',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item5:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    label:'船舶人数',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item6:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    label:'负责人',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                item7:{
                    isShow:true,
                    selectOrinput:false, //1 select 0 input
                    label:'简介',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    value:null,
                },
                length:7
            },
            boxBottom:{
                isBoxBottom:true,
                 input:'',
                 label:'备注'
                
            },
            tableData: [],
            AllClass:this.$store.state.AllClass
        }
    },
    computed:{
        eventModuleId(){
            return this.$store.state.eventModuleIds.equipment
        }
    },
    methods:{
        clearInput(){
            for (let index = 3; index <8; index++) {
                this.groupList[`item${index}`].value = '';
            }
        },
        fullInput(list){
            this.clearInput();
            this.groupList.item3.value = list.age;
            this.groupList.item4.value = parseInt(list.type);
            this.groupList.item5.value = list.personCount;
            this.groupList.item6.value = list.manager;
            this.groupList.item7.value = list.introduce;
        },
        getEQDetailById(){
            let param = {
                action:"get",
                boat_id:this.groupList.item1.value
            }
            API.getEQDetail(param).then((res)=>{
                console.log(res);
                this.fullInput(res.message.obj);
            }).catch(err=>{
                console.log(err);
            })
        },
        addEQ(){
            let param = {
                    action:'add',
                    boat_id:this.groupList.item2.value,
                    boat_name:this.groupList.item2.value,
                    boat_signal:this.groupList.item2.value,
                    type:this.groupList.item4.value,
                    age:this.groupList.item3.value,
                    personCount:this.groupList.item5.value,
                    introduce:this.groupList.item7.value,
                    manager:this.groupList.item6.value,
            }
            API.getEQDetail(param).then(res=>{
                    }).catch(err=>{console.log(err);})
        },
        deleteEQ(){
            let param = {
                    action:'delete',
                    boat_id:this.groupList.item1.value,
            }
            API.getEQDetail(param).then(res=>{
                    }).catch(err=>{console.log(err);})
        },
        handleCheckAllChange(val) {
            this.checkedEvents = val ? this.eventOptions : [];
            this.isIndeterminate = false;
        },
        handleCheckedEventsChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.eventOptions.length;
            this.isIndeterminate = checkedCount > 0 ;
            if(this.checkedEvents.length > 1){
                this.checkedEvents.splice(0,1)
            }
            this.editValue = (this.eventOptions.find(item=>item.value == value[0])).label
        },
        amend(){
            //action=update&eventmoduleid=1&eventtypeid=1&detail=22222&id=3

            let param = {
                    action:'update',
                    boat_id:this.groupList.item1.value,
                    boat_name:this.groupList.item1.value,
                    boat_signal:this.groupList.item1.value,
                    type:this.groupList.item4.value,
                    age:this.groupList.item3.value,
                    personCount:this.groupList.item5.value,
                    introduce:this.groupList.item7.value,
                    manager:this.groupList.item6.value,
            }
            return new Promise((resolve,reject)=>{
                API.getEQDetail(param).then((res)=>{
                this.groupList.item2.value = '';
                    resolve(res)
                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            })
            
        },
        delete(){
            let param = {
                action:'update',
                boatId:this.groupList.item1.value,
                selected:0  
            }
            return new Promise((resolve,reject)=>{
                API.getBoatDetail(param).then((res)=>{
                    resolve(res);
                    this.deleteEQ();
                    this.groupList.item1.value = '';
                    this.clearInput();

                }).catch((err)=>{
                    console.log(err);
                    resolve(0)
                })
            })
            
        },
        addMethod(){
            // action=add&eventName=风水不符&detail=不能说的秘密&eventmodule_id=1

            let list = this.groupList;
                let tmpValue ={
                    action:'update',
                    boatId:this.groupList.item2.value,
                    selected:1,
                    // boat_name:this.groupList.item2.value,
                    // boat_signal:this.groupList.item2.value,
                    // type:this.groupList.item4.value,
                    // age:this.groupList.item3.value,
                    // personCount:this.groupList.item5.value,
                    // introduce:this.groupList.item7.value,
                    // manager:this.groupList.item6.value,
                };
             return new Promise((resolve,reject)=>{
                    API.getBoatDetail(tmpValue).then(res=>{
                        resolve(res)
                        this.addEQ();
                        this.groupList.item2.value = '';
                    }).then(()=>{
                        this.synchrodata();
                    }).catch((err)=>{
                        console.log(err);
                        resolve(0)
                    })
                })
                
                
                
        },
        open() {
            if(!this.verifyMainLabel()){
                this.$message({
                    message: '请填写完整参数',
                    type: 'warning'
                    });
                return
            }else{
                this.$confirm('是否确认入场, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.addMethod().then((message)=>{
                        if(message != 0){
                            this.$message({
                                message: '入场成功',
                                type: 'success'
                            });
                            this.getGroupList();
                            this.clearInput();
                            
                        }else{
                            this.$message({
                            message: '入场失败，请稍后再试',
                            type: 'error'
                            });
                        }
                    })
                })
                .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消添加'
                });          
                });
            }
           
        },
        openAmend(index,row) {
            if(!this.verifyMainLabel()){
                this.$message({
                    message: '请填写完整参数',
                    type: 'warning'
                    });
                return
            }else{
                this.$confirm('是否确认修改, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.amend().then((message)=>{
                        if(message != 0){
                            this.$message({
                            message: '修改成功',
                            type: 'success'
                            });
                        }else{
                            this.$message({
                            message: '修改失败，请稍后再试',
                            type: 'error'
                            });
                        }
                    })
                
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消修改'
                });          
                });
              
            } 
           
        },
        openDelete(index,row) {
           
            this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                this.delete().then((message)=>{
                    if(message != 0){
                        this.$message({
                        message: '删除成功',
                        type: 'success'
                        });
                        this.checkedEvents = [];
                        this.editValue =null;
                        this.synchrodata();
                    }else{
                        this.$message({
                        message: '删除失败，请稍后再试',
                        type: 'error'
                        });
                    }
                })
               
            }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消修改'
            });          
            });
        },
        synchrodata(){  
                    this.getGroupList();
                    this.getTableList();
        },
        submit(){
            if(!this.verifyMainLabel()){
                this.$message({
                    message: '请填写完整参数',
                    type: 'warning'
                    });
                return
            }else{
                this.open()
              
            } 
        },
        verifyMainLabel() {
            let result = true;
           for(var i = 3;i <= this.groupList.length;i++){
                if(`${this.groupList[`item${i}`].value}` == '' ||this.groupList[`item${i}`].value == null){
                    result = false;
                }
            }
            return result
        },
        formatEventTypeList(list){
            let tmpList = [];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].id,
                    label:list[i].eventName,
                })
            }
            return tmpList

        },
        fprmatTableList(list){
            let tmpList = [];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].id,
                    label:list[i].detail,
                    eventtype_id:list[i].eventtype_id,
                    eventmodule_id:list[i].eventmodule_id,
                })
            }
            return tmpList
        },
        formatShipList(list){
            let tmpList = [];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].boat_id,
                    label:list[i].boat_id,
                })
            }
            return tmpList

        },
        formatSignalList(list){
            let tmpList = [];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].boat_id,
                    label:list[i].boat_id,
                })
            }
            return tmpList
        },
        formatTypeList(list){
            let tmpList = [];
            for(var i = 0; i <list.length;i++){
                tmpList.push({
                    value:list[i].id,
                    label:list[i].type,
                })
            }
            return tmpList
        },
        getGroupList(){

            API.getBoatDetail({action:'getallin'}).then((res)=>{
                this.groupList.item1.selectOptions =this.formatSignalList(res.message.obj);
            }).catch((err)=>{
                console.log(err);
            });
            API.getBoatDetail({action:'getallunIn'}).then((res)=>{
                this.groupList.item2.selectOptions =this.formatSignalList(res.message.obj);
            }).catch((err)=>{
                console.log(err);
            });
            API.getBoatType({action:'getall'}).then((res)=>{
                this.groupList.item4.selectOptions =this.formatTypeList(res.message.obj);
            }).catch((err)=>{
                console.log(err);
            });
        },
        getTableList(){
            // let param ={
            //     action:this.$store.state.API_params.action,
            //     eventmodule_id:this.eventModuleId
            // };
            // API.getModuleManagement(param).then((res)=>{
            //     let list =res.message.obj;
            //     let tempList = this.fprmatTableList(list);
            //     this.eventOptions = [];
            //     for(var i = 0;i<tempList.length;i++){
            //     this.eventOptions.push(tempList[i]) ;
            //     }
            // }).catch(err=>{
            //     console.log(err);
            // })
        }
    },
    mounted(){
        this.synchrodata();
    }
}
</script>

<style scoped>

.add_btn1{
    height: 80%;
    width: 40%;
}
.add_btn{
    height: 80%;
    width: 100%;
}
.input_box{
    width: 100%;
}
>>>.el-textarea__inner{
    border: none;
    background-color: var(--subject--input);
    transition: var(--subject--transition);
    line-height: normal;
    color: var(--subject--pop--table-text);
    font-size: 18px;
    /* font-size: 0.9vw; */
}
.bigBox{
    width: 96% !important;
    height: 50% !important;
}
.input_label2{
    width: 100px;
    margin-left: 100px;
    color: var(--subject--text);
    font-size: var(--login--text);
}
.inner_input_box{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
}
.input_group_inner{
    width: 48%;
    height: 25%;
    display: flex;
    align-items: center;
    /* justify-content: center; */
    /* background-color: #1e329a; */
}
.event_management{
    height: 100%;
    width: 90%;
    margin: 0 auto;
}
.table_area{
    margin-top: 3%;
    height: 60%;
    width: 100%;
    border-radius: var(--border--radius);
    background-color: var(--subject--body);
    box-shadow: 0px 2px 20px 5px var(--subject--boxShadow);
}
.newInput_group{
    height: 35%;
    display: flex;
    width: 100%;
    margin-top: 2%;
}

.newInput_group div{
    width: calc(100%/3);
    height: 20%;
}
.div1{
    display: flex;
    justify-content: flex-end;
    padding-right: 5%;
    align-items: center;
    color: var(--subject--title);
}
.div2{
    display: flex;
    align-items: center;
    padding-left: 5%;
}

.el-checkbox{
    margin-left: 15px;
    margin-top: 15px;
    width: 29%;
}
.el-checkbox__label{
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.el-checkbox-group{
    height: 100%;
    width: 100%;
}
.innerInput{
    border: none;
    border-radius: var(--border--radius);
    background-color: var(--subject--input);
    transition: var(--subject--transition);
    color:var(--subject--text) ;
    width: 50%;
    cursor: pointer;
}
.add_box{
    width: 20%;
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: flex-end;
    margin-right: 20%;
}
.add_box1{
    width: 40%;
    height: 50%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-self: flex-end;
    margin-right: 20%;
}
.add_btn_event{
    width: 45%;
    height: 50%;
}
.input_area{
    margin-top: 1%;
    height: 16%;
    width: 100%;
    display: flex;
}
.input_group {
    width: 50%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
}
.newInput_inner{
    width: 100% !important;
}
.delete_btn_event{
    height: 90%;
    width: 20%;
    background-color: var(--subject--delete_btn);
}
.edit_btn_event{
    height: 90%;
    width: 20%;
    background-color: var(--subject--botton);
}
.edit_btn_event:hover{
   background-color: #1e329a;
}

.delete_btn_event:hover{
    background-color: #f54747;
}

</style>>


